import { errorWrapper } from 'commerce/utils/network';
import { client } from '../client';
import { createClientCookiesManager } from '../cookiesManager/client';
import { BasketWith } from './types';

const clientCookiesManager = createClientCookiesManager();

const defaultProductConfig: { with: BasketWith } = {
  with: {
    applicablePromotions: true,

    items: {
      variant: {
        attributes: 'all',
        advancedAttributes: 'all',
      },
      product: {
        attributes: 'all',
        advancedAttributes: 'all',
        categories: 'all', // need for gtm on ckeckout page
      },
    },
  },
};

export const addItem = ({
  variantId,
  quantity,
  customData,
  campaignKey,
}: {
  variantId: number;
  quantity?: number;
  customData?: Record<string, any>;
  campaignKey: string | null;
}) => {
  return errorWrapper(addItem.name, () =>
    client.basket.addOrUpdateItems(
      clientCookiesManager.basketToken,
      [
        {
          variantId,
          quantity: quantity || 1,
          params: {
            ...defaultProductConfig,
            customData,
            ...(campaignKey && { campaignKey }),
          },
        },
      ],
      {
        with: {
          items: {
            promotion: true,
          },
          applicablePromotions: true,
        },
      },
    ),
  );
};

export const updateItem = ({
  itemKey,
  quantity,
  promotionId,
  campaignKey,
}: {
  itemKey: string;
  quantity: number;
  promotionId?: string;
  campaignKey?: string | null;
}) => {
  return errorWrapper(updateItem.name, () =>
    client.basket.updateItem(
      clientCookiesManager.basketToken,
      itemKey,
      quantity,
      {
        ...defaultProductConfig,
        promotionId,
        ...(campaignKey && { campaignKey }),
      },
    ),
  );
};

export const getItems = (campaignKey?: string) => {
  return errorWrapper(getItems.name, () =>
    client.basket.get(clientCookiesManager.basketToken, {
      ...defaultProductConfig,
      campaignKey,
    }),
  );
};

export const removeItem = (itemId: string, campaignKey?: string | null) => {
  return errorWrapper(removeItem.name, () =>
    client.basket.deleteItem(clientCookiesManager.basketToken, itemId, {
      ...defaultProductConfig,
      ...(campaignKey && { campaignKey }),
    }),
  );
};

export const setSenderId = (senderId: string) => {
  clientCookiesManager.setSenderId(senderId);
};

export const setOrderTotalPrice = (price: number) => {
  clientCookiesManager.setOrderTotalPrice(price);
};

export const removeOrderTotalPrice = () => {
  clientCookiesManager.removeOrderTotalPrice();
};

export const setCompanyName = (companyName?: string) => {
  if (!companyName) {
    return;
  }

  clientCookiesManager.setCompanyName(companyName);
};

export const removeCompanyName = () => {
  clientCookiesManager.removeCompanyName();
};
